const sampleTransformationScript = `//JSM ASSET FILTER EXAMPLE
// TAKES THE ASSET AQL RESPONSE
const input = context?.data;
//FILTERS ON ATTRIBUTE IDs, EMPTY MEANS ALL ATTRIBUTES INCLUDED
const attributeIds = [];

const wanted = new Set((attributeIds || []).map(String));
const includeAll = wanted.size === 0;

return {
  // keep paging/meta fields
  maxResults: input.maxResults,
  startAt: input.startAt,
  total: input.total,
  isLast: input.isLast,
  hasMoreResults: input.hasMoreResults,
  last: input.last,

  values: Array.isArray(input.values)
    ? input.values.map((v) => {
        const { avatar, objectType, attributes, ...rest } = v;

        const slimAttributes = Array.isArray(attributes)
          ? attributes
              .filter((a) => includeAll || wanted.has(String(a.id)))
              .map((a) => {
                const { workspaceId, globalId, ...aRest } = a; // drop
                return aRest;
              })
          : attributes;

        return {
          ...rest,
          objectType: objectType ? { id: objectType.id, name: objectType.name } : objectType,
          attributes: slimAttributes,
        };
      })
    : input.values,
};
`;

export default sampleTransformationScript;
